'use es6';

import getIn from 'transmute/getIn';
import { CRM_CREATION_SOURCE } from '../constants/keyPaths';
export const isFormSubmission = message => !!getIn(CRM_CREATION_SOURCE, message);